// @ts-nocheck
// TODO: tighten types after migration
import React, { useMemo, useState } from 'react';

function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';

  // Covers common social in-app browsers and Android WebView signatures.
  return /(FBAN|FBAV|Instagram|Twitter|Line\/(?:\d|)|LinkedInApp|TikTok|Snapchat|Pinterest|; wv\)|\bwv\b)/i.test(ua);
}

function buildAndroidIntentUrl(rawUrl) {
  const safeUrl = String(rawUrl || '').trim();
  if (!safeUrl) return '';

  const noProtocol = safeUrl.replace(/^https?:\/\//i, '');
  return `intent://${noProtocol}#Intent;scheme=https;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end`;
}

function buildIosSafariUrl(rawUrl) {
  const safeUrl = String(rawUrl || '').trim();
  if (!safeUrl) return '';

  if (/^https:\/\//i.test(safeUrl)) {
    return safeUrl.replace(/^https:\/\//i, 'x-safari-https://');
  }

  if (/^http:\/\//i.test(safeUrl)) {
    return safeUrl.replace(/^http:\/\//i, 'x-safari-http://');
  }

  return `x-safari-https://${safeUrl}`;
}

export default function InAppBrowserRedirect() {
  const [dismissed, setDismissed] = useState(false);

  const shouldShow = useMemo(() => {
    return !dismissed && isInAppBrowser();
  }, [dismissed]);

  const openInDefaultBrowser = () => {
    if (typeof window === 'undefined') return;

    const currentUrl = window.location.href;
    const ua = navigator.userAgent || '';
    const isAndroid = /android/i.test(ua);
    const isIOS = /iphone|ipad|ipod/i.test(ua);

    if (isAndroid) {
      const intentUrl = buildAndroidIntentUrl(currentUrl);
      if (intentUrl) {
        window.location.href = intentUrl;
        window.setTimeout(() => {
          window.open(currentUrl, '_blank', 'noopener,noreferrer');
        }, 900);
        return;
      }
    }

    if (isIOS) {
      const safariUrl = buildIosSafariUrl(currentUrl);
      if (safariUrl) {
        window.location.href = safariUrl;
        window.setTimeout(() => {
          window.open(currentUrl, '_blank', 'noopener,noreferrer');
        }, 900);
        return;
      }
    }

    window.open(currentUrl, '_blank', 'noopener,noreferrer');
  };

  if (!shouldShow) return null;

  return (
    <div className="fixed left-1/2 top-[12px] z-[9999] -translate-x-1/2 w-[min(94vw,680px)] rounded-[14px] border border-black/10 bg-white/95 px-[12px] py-[10px] shadow-[0_10px_28px_rgba(0,0,0,0.18)] backdrop-blur-[8px] dark-mode:border-white/20 dark-mode:bg-[#1f1f1fe8]">
      <div className="flex items-center justify-between gap-[10px]">
        <p className="m-0 text-[13px] leading-[1.4] text-[#1f1f1f] dark-mode:text-[#f2f2f2]">
          For best experience, open this page in your device browser.
        </p>
        <div className="flex items-center gap-[8px]">
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="cursor-pointer rounded-[10px] border border-black/10 bg-transparent px-[10px] py-[6px] text-[12px] text-[#444] transition-colors hover:bg-black/5 dark-mode:border-white/20 dark-mode:text-[#ddd] dark-mode:hover:bg-white/10"
            aria-label="Dismiss"
          >
            Later
          </button>
          <button
            type="button"
            onClick={openInDefaultBrowser}
            className="cursor-pointer rounded-[10px] border-0 bg-[#1b8cff] px-[11px] py-[7px] text-[12px] font-semibold text-white transition-colors hover:bg-[#1477db]"
            aria-label="Open in default browser"
          >
            Open in Browser
          </button>
        </div>
      </div>
    </div>
  );
}
